import React from "react";
import NotebookJSONDashboard from "./dashboardJSON/components/NotebookJSONDashboard_test";
import { dashboardData } from "./dashboardJSON/components/dashboardData";

const AppJSON = () => {
  console.log("DashboardData loaded:", dashboardData);
  return <NotebookJSONDashboard dashboardData={dashboardData} />;
};

export default AppJSON;
